/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CellSignalLow(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M198.12305,28.53186a15.95427,15.95427,0,0,0-17.4375,3.46826L74.34692,138.33948l-.00415.0039L16.001,196.68616a15.99945,15.99945,0,0,0,11.3125,27.314H192a16.01833,16.01833,0,0,0,16-16V43.3136A15.95272,15.95272,0,0,0,198.12305,28.53186ZM192,208.00012,88,207.9967V147.31653L192,43.32043Z" />
    </Svg>
  );
}

export default CellSignalLow;
